import React from "react";
import { Modal } from "antd";

interface GenericDialogProps {
  open: boolean;
  width?: number;
  submitButtonText?: string;
  cancelButtonText?: string;
  okButtonLoading?: boolean;
  isDisabled?: boolean;
  title: string;
  description: string | React.ReactNode;
  titleIcon: React.ReactNode;
  handleCancel: () => void;
  handleSubmit: () => void;
}

const GenericDialog: React.FC<GenericDialogProps> = ({
  open,
  width,
  submitButtonText,
  cancelButtonText,
  title,
  titleIcon,
  description,
  handleCancel,
  handleSubmit,
  okButtonLoading,
  isDisabled
}) => {
  return (
      <Modal
        open={open}
        width={width}
        className="model"
        closable={false}
        cancelText={cancelButtonText ?? "No"}
        okText={submitButtonText ?? "Yes"}
        onCancel={handleCancel}
        onOk={handleSubmit}
        title={
          <span style={{ fontSize: 20 }}>
            {" "}
            {titleIcon}{title}
          </span>
        }
        centered={true}
        okButtonProps={{
          style: { backgroundColor: isDisabled ? "#f5f5f5" : "#008576", color: isDisabled ? "#bfbfbf" : "white" },
          loading: okButtonLoading,
          disabled: isDisabled,
        }}
        cancelButtonProps={{
          className: "custom-cancel-button",
          disabled: okButtonLoading,
        }}
      >
        <div style={{ margin: "-20px 0 20px 30px" }}>
          {description}
        </div>
      </Modal>
  );
};

export default GenericDialog;
